<template>
    <div>
        <div ref="jsonContainerRef"></div>
        <div class="p-2">
            <b-button variant="light" @click="reset" v-if="showResetBtn">Reset</b-button>
            <b-button class="ml-4" variant="light" @click="copyToClipboard" v-if="showPdvNameBtn">[Nom du PDV] <img src="@/assets/images/icons/button-copy.png" alt="copy" /></b-button>
        </div>
    </div>
</template>

<script>
    import { createJSONEditor } from 'vanilla-jsoneditor';
    export default {
        name: 'JsonEditor',
        props: {
            content: {
                type: Object,
                required: true,
            },
            showResetBtn: {
                type: Boolean,
                default: false,
            },
            showPdvNameBtn: {
                type: Boolean,
                default: false,
            },
            readOnly: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                value: { json: {} },
                refEditor: null,
            };
        },
        computed: {},
        mounted() {
            if (this.$refs.jsonContainerRef) {
                this.refEditor = createJSONEditor({
                    target: this.$refs.jsonContainerRef,
                    props: {
                        content: this.content || { json: {} },
                        onChange: (json) => {
                            if (json.json) {
                                this.$set(this, 'value', json.json);
                            } else {
                                this.$set(this, 'value', JSON.parse(json.text));
                            }
                            this.$emit('onUpdateJsonContent', this.value);
                        },
                        readOnly: this.readOnly,
                    },
                });
            }
        },
        methods: {
            reset() {
                if (!this.content) return;
                this.$set(this, 'value', this.content);

                if (this.$refs.jsonContainerRef) {
                    this.refEditor.update(this.content);
                }
            },
            copyToClipboard() {
                navigator.clipboard.writeText('[Nom du PDV]').then(
                    () => {
                        this.$emit('successToast', 'copied to clipboard');
                    },
                    (err) => {
                        console.error('Could not copy text: ', err);
                    }
                );
            },
        },
        watch: {
            content: {
                handler(newVal) {
                    this.reset();
                },
                deep: true,
            },
        },
    };
</script>

<style scoped></style>
